// extracted by mini-css-extract-plugin
module.exports = {"link":"_fd4d44d"};